/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-10 18:30:25
 * @LastEditTime: 2022-01-11 14:48:11
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 银联对账单汇总列表
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/YLPayOrderSummaryList/index.jsx
 */
import React, { useRef } from 'react'
import TableHelper from '../../../components/TableHelper'
import { fetchPlatformRecordYlPayOrderSummaryList } from '../../../services/platformAccountingRecord'
import { formatTime } from '../../../utils'
import YLPayOrderSummaryDetail from './detail'

const YLPayOrderSummaryList = (props) => {

    let YLPayOrderSummaryDetailRef = useRef()
    const columns = [
        { title: '商户集团编号', dataIndex: 'merchantGroupNumber' },
        { title: '交易金额', dataIndex: 'tradeAmount' },
        { title: '手续费', dataIndex: 'serviceCharge'},
        {
            title: '清算金额', dataIndex: 'liquidationAmount'
        },
        { title: '交易笔数', dataIndex: 'tradeNum' },
        { title: '对账文件名称', dataIndex: 'fileName', render: (text, record) => {
            return <a href={record.fileUrl} download target="view_frame">{text}</a>
        } },
        { title: '创建时间', dataIndex: 'createTime', render: text => formatTime(text, 'YYYY-MM-DD HH:mm') },
        { title: '操作', dataIndex: 'action', render: (text, record) => {
            return (
                <a onClick={() =>YLPayOrderSummaryDetailRef.open(record.id)}>详情</a>
            )
        }  }
    ]

    const searchOptions = [
        { key: 'startDate', type: 'date', placeholder: '开始日期' },
        { key: 'endDate', type: 'date', placeholder: '结束日期' },
    ]
    return (
        <div>
            <TableHelper columns={columns} searchOptions={searchOptions} request={fetchPlatformRecordYlPayOrderSummaryList} />
            <YLPayOrderSummaryDetail getRef={ref => YLPayOrderSummaryDetailRef = ref} />
        </div>
    )
}

export default YLPayOrderSummaryList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/YLPayOrderSummaryList/index.jsx